"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
var tryBackgroundAuth_1 = require("./tryBackgroundAuth");
var isExplicitLogonRequest_1 = require("./isExplicitLogonRequest");
function fetchHandler(actionName, response, requestOptions) {
    var isNoError = handleErrors(actionName, response, requestOptions);
    if (requestOptions.returnFullResponseOnSuccess) {
        return isNoError ? Promise.resolve(response) : Promise.reject(response);
    }
    if (isNoError) {
        return response.json().then(function (body) {
            if (typeof body == "object" && !body.originalFetchHeaders) {
                body.originalFetchHeaders = response.headers;
            }
            return body;
        }).catch(function (e) {
            throw createServerFailureError(actionName, e);
        });
    }
    else {
        return null;
    }
}
exports.default = fetchHandler;
function isAuthNeeded(requestOptions) {
    return !(isExplicitLogonRequest_1.default(requestOptions) || (requestOptions && requestOptions.authNeededOnUnAuthorized === false));
}
/**
 * Handles response errors. Returns true if no errors
 */
function handleErrors(actionName, response, requestOptions) {
    if ((response.status == 401 /* Unauthorized */ || response.status == 440 /* SessionTimeout */)) {
        if (config_1.getConfig().onAuthNeeded && isAuthNeeded(requestOptions)) {
            config_1.getConfig().onAuthNeeded();
            return false;
        }
    }
    else if (!response.ok) {
        // Check if client is getting OwaHipRequiredExcpetion then he should be redirected to jsMvvm hip control
        // After user successfuly resolve captcha, he will be redirected to /owa which will force opt in user to /mail
        if (response.status == 412 /* PreconditionFailed */) {
            if (config_1.getConfig().onHipChallengeNeeded && config_1.getConfig().onHipChallengeNeeded(response.headers)) {
                return false;
            }
        }
        var errorMessage = response.statusText;
        if (!errorMessage && response.headers) {
            errorMessage = response.headers.get('x-owa-error');
        }
        var responseError = createServerFailureError(actionName, errorMessage);
        responseError.response = response;
        throw responseError;
    }
    if (response.headers.get('X-OWA-STO') != null) {
        tryBackgroundAuth_1.tryBackgroundAuth(window);
    }
    return true;
}
function createServerFailureError(actionName, message) {
    var responseError = (new Error(actionName + " failed: " + message));
    responseError.fetchErrorType = 'ServerFailure';
    responseError.knownError = true;
    return responseError;
}
